import React, { Component } from 'react'
import {
  Button,
  IconButton,
  InputAdornment,
  TextField
} from '@material-ui/core'
import { FB_API_URL } from '../lib/env'
import axios from 'axios'
import CustomNumberFormat from '../components/custom_number_format'
import PrintCreditRequest from '../pages/print_credit_request'
import VisibilityIcon from '@material-ui/icons/Visibility'

class ViewCreditRequest extends Component {
  constructor(props) {
    super(props)

    this.state = {
      token: localStorage.getItem('token'),
      isPrintModalOpen: false,
      sentToKmf: props.sentToKmf,

      // Сведения о кредите
      creditPurpose: 'Приобретение нового автотранспорта',
      totalPrice: '',
      downPaymentAmount: '',
      creditAmount: '',
      creditTerm: '',
      repaymentMethod: 'Аннуитетный',
      simplifiedFin: '',
      dealerName: '',

      // Обеспечение
      creditObjectName: 'Транспортное средство',
      carBrand: '',
      carModel: '',
      carManufactureCountry: '',
      carYear: '',
      carWheel: '',
      carMileage: '',
      carVinCode: '',

      // Сведения о Заемщике
      clientFirstname: '',
      clientLastname: '',
      clientPatronymic: '',
      clientIIN: '',
      clientDateOfBirth: '',
      clientGender: '',
      clientCitizenship: '',
      clientEducationLevel: '',
      clientPlaceOfBirth: '',
      clientResidency: '',
      clientResidencyName: '',
      clientDocumentNumber: '',
      clientDocumentInfo: '',
      clientDocumentInfoName: '',
      clientDocumentIssuer: '',
      clientDocumentIssuerName: '',
      clientDocumentIssueDate: '',
      clientDocumentExpireDate: '',
      clientChangedName: '',
      clientIsPledger: '',
      clientMaritalStatus: '',
      clientMaritalStatusName: '',
      clientDependentsNumber: '',
      clientChildCount: '',
      clientSpouseInfo: '',
      clientRegistrationAddress: '',
      clientActualAddress: '',
      clientRegistrationAddressEqualsActualAddress: 'Нет',
      clientRightOfResidence: '',
      clientMobilePhoneNumber: '',
      clientWorkPhoneNumber: '',

      // Информация о работе
      employerFullName: '',
      employerActivity: '',
      jobPositionCategory: '',
      jobPosition: '',
      employmentStatus: '',
      employmentStatusName: '',
      workExperienceInMonths: '',
      workExperienceInMonthsAtLastPosition: '',

      // Информация о среднемесячных доходах и расходах
      mainIncome: '',
      spouseIncome: '',
      totalExpenses: '',

      // Дополнительные контакты
      contact1Name: '',
      contact1PhoneNumber: '',
      contact1Relationship: '',
      contact1RelationshipName: '',
      contact2Name: '',
      contact2PhoneNumber: '',
      contact2Relationship: '',
      contact2RelationshipName: '',
      contact3Name: '',
      contact3PhoneNumber: '',
      contact3Relationship: '',
      contact3RelationshipName: ''
    }
  }

  componentDidMount() {
    this.getCreditRequest()
  }

  getClientPhone(id) {
    let self = this
    this.setState({
      clientMobilePhoneNumber: ''
    })

    axios
      .get(FB_API_URL + '/finbroker/credit_request/phone/' + id, {
        headers: {
          Authorization: `Bearer ${this.state.token}`
        }
      })
      .then(function (response) {
        console.log(response.data)

        self.setState({
          clientMobilePhoneNumber: response.data.clientMobilePhoneNumber
        })
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }

  getCreditRequest() {
    let self = this
    let id = this.props.creditRequest.id

    axios
      .get(FB_API_URL + '/finbroker/credit_request/' + id, {
        headers: {
          Authorization: `Bearer ${this.state.token}`
        }
      })
      .then(function (response) {
        console.log(response.data)
        switch (response.data.contact1Relationship) {
          case '9':
            self.setState({ contact1RelationshipName: 'Коллега' })
            break
          case '7':
            self.setState({ contact1RelationshipName: 'Сын' })
            break
          case '4':
            self.setState({ contact1RelationshipName: 'Сестра' })
            break
          case '1':
            self.setState({ contact1RelationshipName: 'Муж' })
            break
          case '3':
            self.setState({ contact1RelationshipName: 'Брат' })
            break
          case '5':
            self.setState({ contact1RelationshipName: 'Мать' })
            break
          case '6':
            self.setState({ contact1RelationshipName: 'Отец' })
            break
          case '2':
            self.setState({ contact1RelationshipName: 'Жена' })
            break
          case '8':
            self.setState({ contact1RelationshipName: 'Дочь' })
            break
          case '11':
            self.setState({ contact1RelationshipName: 'Друг/Подруга' })
            break
          case '10':
            self.setState({ contact1RelationshipName: 'Другой родственник' })
            break
          default:
            break
        }

        // TODO: add positionCode (Категория занимаемой должности)
        // TODO: industry type code
        // TODO: add docIssueDate, docExpireDate, docNumber

        switch (response.data.contact2Relationship) {
          case '9':
            self.setState({ contact2RelationshipName: 'Коллега' })
            break
          case '7':
            self.setState({ contact2RelationshipName: 'Сын' })
            break
          case '4':
            self.setState({ contact2RelationshipName: 'Сестра' })
            break
          case '1':
            self.setState({ contact2RelationshipName: 'Муж' })
            break
          case '3':
            self.setState({ contact2RelationshipName: 'Брат' })
            break
          case '5':
            self.setState({ contact2RelationshipName: 'Мать' })
            break
          case '6':
            self.setState({ contact2RelationshipName: 'Отец' })
            break
          case '2':
            self.setState({ contact2RelationshipName: 'Жена' })
            break
          case '8':
            self.setState({ contact2RelationshipName: 'Дочь' })
            break
          case '11':
            self.setState({ contact2RelationshipName: 'Друг/Подруга' })
            break
          case '10':
            self.setState({ contact2RelationshipName: 'Другой родственник' })
            break
          default:
            break
        }

        switch (response.data.contact3Relationship) {
          case '9':
            self.setState({ contact3RelationshipName: 'Коллега' })
            break
          case '7':
            self.setState({ contact3RelationshipName: 'Сын' })
            break
          case '4':
            self.setState({ contact3RelationshipName: 'Сестра' })
            break
          case '1':
            self.setState({ contact3RelationshipName: 'Муж' })
            break
          case '3':
            self.setState({ contact3RelationshipName: 'Брат' })
            break
          case '5':
            self.setState({ contact3RelationshipName: 'Мать' })
            break
          case '6':
            self.setState({ contact3RelationshipName: 'Отец' })
            break
          case '2':
            self.setState({ contact3RelationshipName: 'Жена' })
            break
          case '8':
            self.setState({ contact3RelationshipName: 'Дочь' })
            break
          case '11':
            self.setState({ contact3RelationshipName: 'Друг/Подруга' })
            break
          case '10':
            self.setState({ contact3RelationshipName: 'Другой родственник' })
            break
          default:
            break
        }

        switch (response.data.clientMaritalStatus) {
          case '1':
            self.setState({ clientMaritalStatusName: 'Холост/Не замужем' })
            break
          case '2':
            self.setState({ clientMaritalStatusName: 'Женат/Замужем' })
            break
          case '3':
            self.setState({ clientMaritalStatusName: 'Вдовец/Вдова' })
            break
          case '4':
            self.setState({ clientMaritalStatusName: 'Разведен/Разведена' })
            break
          case '5':
            self.setState({ clientMaritalStatusName: 'Повторно женат/замужем' })
            break
          case '6':
            self.setState({ clientMaritalStatusName: 'Гражданский брак' })
            break
          case '7':
            self.setState({ clientMaritalStatusName: 'Иное' })
            break
          case '0':
            self.setState({ clientMaritalStatusName: 'Не определено' })
            break
          default:
            break
        }

        switch (response.data.employmentStatus) {
          case '1':
            self.setState({ employmentStatusName: 'Временно безработный' })
            break
          case '2':
            self.setState({ employmentStatusName: 'Безработный' })
            break
          case '3':
            self.setState({ employmentStatusName: 'На пенсии' })
            break
          case '4':
            self.setState({ employmentStatusName: 'Работа по найму' })
            break
          case '5':
            self.setState({ employmentStatusName: 'Собственный бизнес' })
            break
          default:
            break
        }

        switch (response.data.clientResidency) {
          case '1':
            self.setState({ clientResidencyName: 'Резидент' })
            break
          case '2':
            self.setState({ clientResidencyName: 'Нерезидент' })
            break
          default:
            break
        }

        switch (response.data.clientDocumentIssuer) {
          case '1':
            self.setState({ clientDocumentIssuerName: 'МВД РК' })
            break
          case '2':
            self.setState({ clientDocumentIssuerName: 'МЮ РК' })
            break
          case '3':
            self.setState({ clientDocumentIssuerName: 'Иное' })
            break
          default:
            break
        }

        switch (response.data.clientDocumentInfo) {
          case '01':
            self.setState({ clientDocumentInfoName: 'Паспорт гражданина РК' })
            break
          case '04':
            self.setState({ clientDocumentInfoName: 'Удостоверение личности' })
            break
          case '12':
            self.setState({
              clientDocumentInfoName: 'Свидетельство о рождении'
            })
            break
          case '13':
            self.setState({ clientDocumentInfoName: 'Удостоверение беженца' })
            break
          case '03':
            self.setState({
              clientDocumentInfoName: 'Паспорт иностранного гос-ва'
            })
            break
          case '09':
            self.setState({
              clientDocumentInfoName: 'Уд-ние лица без гражданства'
            })
            break
          case '10':
            self.setState({
              clientDocumentInfoName: 'Вид на жительство ин-ца в РК'
            })
            break
          default:
            break
        }

        switch (response.data.clientGender) {
          case 'F':
            self.setState({ clientGender: 'Женский' })
            break
          case 'M':
            self.setState({ clientGender: 'Мужской' })
            break
          default:
            break
        }

        switch (response.data.jobPositionCategory) {
          case '1':
            self.setState({ jobPositionCategory: 'Старший специалист' })
            break
          case '2':
            self.setState({
              jobPositionCategory: 'Управление (нач. отдела, управления)'
            })
            break
          case '3':
            self.setState({
              jobPositionCategory: 'Общее управление организацией'
            })
            break
          case '4':
            self.setState({ jobPositionCategory: 'Специалист' })
            break
          case '5':
            self.setState({ jobPositionCategory: 'Рабочий' })
            break
          default:
            break
        }

        self.setState({
          creditPurpose: response.data.creditPurpose,
          totalPrice: response.data.totalPrice,
          downPaymentAmount: response.data.downPaymentAmount,
          creditAmount: response.data.creditAmount,
          creditTerm: response.data.creditTerm,
          repaymentMethod: response.data.repaymentMethod,
          simplifiedFin: response.data.simplifiedFin,
          dealerName: response.data.dealerName,

          // Обеспечение
          creditObjectName: response.data.creditObjectName,
          carBrand: response.data.carBrand,
          carModel: response.data.carModel,
          carManufactureCountry: response.data.carManufactureCountry,
          carYear: response.data.carYear,
          carWheel: response.data.carWheel,
          carMileage: response.data.carMileage,
          carVinCode: response.data.carVinCode,

          // Сведения о Заемщике
          clientFirstname: response.data.clientFirstname,
          clientLastname: response.data.clientLastname,
          clientPatronymic: response.data.clientPatronymic,
          clientIIN: response.data.clientIIN,
          clientDateOfBirth: response.data.clientDateOfBirth,
          clientCitizenship: response.data.clientCitizenship,
          clientEducationLevel: response.data.clientEducationLevel,
          clientPlaceOfBirth: response.data.clientPlaceOfBirth,
          clientResidency: response.data.clientResidency,
          clientDocumentInfo: response.data.clientDocumentInfo,
          clientDocumentNumber: response.data.clientDocumentNumber,
          clientDocumentIssuer: response.data.clientDocumentIssuer,
          clientDocumentIssueDate: response.data.clientDocumentIssueDate,
          clientDocumentExpireDate: response.data.clientDocumentExpireDate,
          clientChangedName: response.data.clientChangedName,
          clientIsPledger: response.data.clientIsPledger,
          clientMaritalStatus: response.data.clientMaritalStatus,
          clientDependentsNumber: response.data.clientDependentsNumber,
          clientChildCount: response.data.clientChildCount,
          clientSpouseInfo: response.data.clientSpouseInfo,
          clientRegistrationAddress: response.data.clientRegistrationAddress,
          clientActualAddress: response.data.clientActualAddress,
          clientRegistrationAddressEqualsActualAddress:
            response.data.clientRegistrationAddressEqualsActualAddress,
          clientRightOfResidence: response.data.clientRightOfResidence,
          clientMobilePhoneNumber: response.data.clientMobilePhoneNumber,
          clientWorkPhoneNumber: response.data.clientWorkPhoneNumber,

          // Информация о работе
          employerFullName: response.data.employerFullName,
          employerActivity: response.data.employerActivity,
          jobPosition: response.data.jobPosition,
          employmentStatus: response.data.employmentStatus,
          workExperienceInMonths: response.data.workExperienceInMonths,
          workExperienceInMonthsAtLastPosition:
            response.data.workExperienceInMonthsAtLastPosition,

          // Информация о среднемесячных доходах и расходах
          mainIncome: response.data.mainIncome,
          spouseIncome: response.data.spouseIncome,
          totalExpenses: response.data.totalExpenses,

          // Дополнительные контакты
          contact1Name: response.data.contact1Name,
          contact1PhoneNumber: response.data.contact1PhoneNumber,
          contact1Relationship: response.data.contact1Relationship,
          contact2Name: response.data.contact2Name,
          contact2PhoneNumber: response.data.contact2PhoneNumber,
          contact2Relationship: response.data.contact2Relationship,
          contact3Name: response.data.contact3Name,
          contact3PhoneNumber: response.data.contact3PhoneNumber,
          contact3Relationship: response.data.contact3Relationship,
          id: response.data.id
        })
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }

  render() {
    return (
      <div>
        <div style={{ textAlign: 'center' }}>
          <form>
            <div style={{ display: 'inline-block', marginBottom: '20px' }}>
              <div style={{ textAlign: 'left' }}>
                <Button
                  className="button_small button_green_color no-print"
                  style={{ marginBottom: '10px' }}
                  onClick={() => {
                    window.onbeforeprint = () => {
                      console.log('before')
                      document.getElementsByClassName(
                        'MuiTable-root'
                      )[0].style.display = 'none'
                    }
                    window.print()
                    document.getElementsByClassName(
                      'MuiTable-root'
                    )[0].style.display = 'block'
                  }}
                >
                  Печать
                </Button>
                {this.state.sentToKmf && (
                  <>
                    <Button
                      className="button_small button_green_color no-print"
                      style={{ marginBottom: '10px', marginLeft: '10px' }}
                      onClick={() =>
                        this.setState({
                          isPrintModalOpen: !this.state.isPrintModalOpen
                        })
                      }
                    >
                      {!this.state.isPrintModalOpen
                        ? 'Заявление кмф'
                        : 'Сведения о кредите'}
                    </Button>
                  </>
                )}
              </div>
              {this.state.isPrintModalOpen ? (
                <PrintCreditRequest state={this.state} />
              ) : (
                <>
                  <div style={{ textAlign: 'left', marginTop: '15px' }}>
                    <div className="title">
                      Сведения о запрашиваемом кредите
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.creditPurpose}
                        InputProps={{
                          className: 'textfield_green',
                          readOnly: true
                        }}
                        fullWidth={true}
                        label="Цель кредитования"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.repaymentMethod}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Метод погашения"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.simplifiedFin}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="С подтверждением дохода"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.dealerName}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Юридическое лицо по ДКП"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.totalPrice}
                        InputProps={{
                          inputComponent: CustomNumberFormat,
                          className: 'textfield_green'
                        }}
                        fullWidth={true}
                        label="Сумма ДКП"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.downPaymentAmount}
                        InputProps={{
                          inputComponent: CustomNumberFormat,
                          className: 'textfield_green'
                        }}
                        fullWidth={true}
                        label="Сумма первоначального взноса"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.creditAmount}
                        InputProps={{
                          inputComponent: CustomNumberFormat,
                          className: 'textfield_green'
                        }}
                        fullWidth={true}
                        label="Сумма кредита"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.creditTerm}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="number"
                        label="Срок кредита (мес)"
                      />
                    </div>
                  </div>
                  <div style={{ textAlign: 'left', marginTop: '30px' }}>
                    <div className="title">Обеспечение</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.carBrand}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Марка ТС"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.carModel}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Модель ТС"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.carYear}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="number"
                        label="Год выпуска"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.carVinCode}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="text"
                        label="VIN код"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.carManufactureCountry}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Страна производитель марки ТС"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.carWheel}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Руль"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.carMileage}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="number"
                        label="Пробег"
                      />
                    </div>
                  </div>
                  <div style={{ textAlign: 'left', marginTop: '30px' }}>
                    <div className="title">Сведения о заемщике</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Фамилия"
                        value={this.state.clientLastname}
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.clientFirstname}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Имя"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Отчество"
                        value={this.state.clientPatronymic}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="ИИН"
                        value={this.state.clientIIN}
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        id="date"
                        label="Дата рождения"
                        type="date"
                        fullWidth={true}
                        value={this.state.clientDateOfBirth}
                        InputProps={{ className: 'textfield_green' }}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.clientGender}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Пол"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.clientCitizenship}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Гражданство"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.clientEducationLevel}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Образование"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.clientPlaceOfBirth}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Место рождения"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.clientResidencyName}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Признак резиденства"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Вид документа, уд. лич."
                        value={this.state.clientDocumentInfoName}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Номер документа, уд.лич."
                        value={this.state.clientDocumentNumber}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Орган выдачи документа, уд.лич."
                        value={this.state.clientDocumentIssuerName}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        id="date"
                        label="Дата выдачи документа"
                        type="date"
                        fullWidth={true}
                        value={this.state.clientDocumentIssueDate}
                        InputProps={{ className: 'textfield_green' }}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        id="date"
                        label="Срок действия документа"
                        type="date"
                        fullWidth={true}
                        value={this.state.clientDocumentExpireDate}
                        InputProps={{ className: 'textfield_green' }}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Изменение ФИО"
                        value={this.state.clientChangedName}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '240px'
                      }}
                    >
                      <TextField
                        value={this.state.clientIsPledger}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Являетесь ли залогодателем?"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '240px'
                      }}
                    >
                      <TextField
                        value={this.state.clientMaritalStatusName}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Семейное положение"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '240px'
                      }}
                    >
                      <TextField
                        value={this.state.clientDependentsNumber}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="number"
                        label="Количество иждивенцев"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '240px'
                      }}
                    >
                      <TextField
                        value={this.state.clientChildCount}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="number"
                        label="Количество детей"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Данные по супругу/супруге"
                        value={this.state.clientSpouseInfo}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Адрес регистрации"
                        value={this.state.clientRegistrationAddress}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={
                          this.state
                            .clientRegistrationAddressEqualsActualAddress
                        }
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Адрес фактического проживания совпадает с адресом регистрации?"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.clientRightOfResidence}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Право проживания"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Адрес фактического проживания"
                        value={this.state.clientActualAddress}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  ></div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '120px'
                      }}
                    >
                      <TextField
                        value={this.state.clientMobilePhoneNumber}
                        InputProps={{
                          className: 'textfield_green',
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                color="primary"
                                onClick={() =>
                                  this.getClientPhone(
                                    this.props.creditRequest.id
                                  )
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        fullWidth={true}
                        label="Мобильный телефон"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.clientWorkPhoneNumber}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Рабочий телефон"
                      />
                    </div>
                  </div>
                  <div style={{ textAlign: 'left', marginTop: '30px' }}>
                    <div className="title">Информация о работе</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.employerFullName}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Полное наименование компании/организации"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.employerActivity}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Вид деятельности организации"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.jobPositionCategory}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Категория занимаемой должности"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.jobPosition}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Должность"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.employmentStatusName}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Статус занятости"
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.workExperienceInMonths}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="number"
                        label="Стаж работы общий (мес)"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.workExperienceInMonthsAtLastPosition}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="number"
                        label="Стаж на последнем месте работы (мес)"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  ></div>
                  <div style={{ textAlign: 'left', marginTop: '30px' }}>
                    <div className="title">
                      Информация о среднемесячных доходах и расходах
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.mainIncome}
                        InputProps={{
                          inputComponent: CustomNumberFormat,
                          className: 'textfield_green'
                        }}
                        fullWidth={true}
                        label="Доходы от основной деятельности"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.spouseIncome}
                        InputProps={{
                          inputComponent: CustomNumberFormat,
                          className: 'textfield_green'
                        }}
                        fullWidth={true}
                        label="Дополнительный доход"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.totalExpenses}
                        InputProps={{
                          inputComponent: CustomNumberFormat,
                          className: 'textfield_green'
                        }}
                        fullWidth={true}
                        label="Всего совокупный расход"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  ></div>
                  <div style={{ textAlign: 'left', marginTop: '30px' }}>
                    <div className="title">Дополнительные контакты</div>
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '20px' }}>Контактное лицо #1</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact1Name}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="ФИО"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact1PhoneNumber}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Номер телефона"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact1RelationshipName}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Кем приходится заемщику"
                      />
                    </div>
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '20px' }}>Контактное лицо #2</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact2Name}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="ФИО"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact2PhoneNumber}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Номер телефона"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact2RelationshipName}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Кем приходится заемщику"
                      />
                    </div>
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '20px' }}>Контактное лицо #3</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact3Name}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="ФИО"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact3PhoneNumber}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Номер телефона"
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact3RelationshipName}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Кем приходится заемщику"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default ViewCreditRequest
